import { Component, OnInit } from '@angular/core';
import {TipoLayout} from "../../../shared/models/tipo-layout";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AppComponent} from "../../../app.component";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {CabecalhoLayout} from "../../../shared/models/cabecalho-layout";
import {CabecalhoLayoutService} from "../../../core/services/cabecalho-layout.service";
import {TipoLayoutService} from "../../../core/services/tipo-layout.service";
import {CampoCabecalhoLayout} from "../../../shared/models/campo-cabecalho-layout";

@Component({
  selector: 'app-cabecalho-form',
  templateUrl: './cabecalho-form.component.html',
  styleUrls: ['./cabecalho-form.component.css']
})
export class CabecalhoFormComponent implements OnInit {

  public breadCrumb;
  public cabecalho_layout: CabecalhoLayout;
  public tipos_layout: Array<TipoLayout> = [];
  public form: FormGroup;
  public form_campos: FormGroup;
  // public schemas: Array<Schema> = [];
  // public tabelas: Array<Tabela> = [];
  // public campos: Array<Campo> = [];
  public existe_padrao: boolean = true;

  constructor(private appComponent: AppComponent,
              private cabecalhoLayoutService: CabecalhoLayoutService,
              private tipoLayoutService: TipoLayoutService,
              /*private tabelaService: TabelaService,*/
              private router: Router,
              private notifierService: NotifierService) {

  }

  ngOnInit() {
    this.breadCrumb = [
      {nome: "Configuração", caminho: "/configuracao"},
      {nome: "Cabeçalho", caminho: "/layout/cabecalho"}
    ];
    this.appComponent.setTitulo('Cabeçalho');
    this.appComponent.setBreadcrumb(this.breadCrumb);
    this.cabecalho_layout = new CabecalhoLayout();
    this.form = new FormGroup({
      codigo_tipo_layout: new FormControl("", [
        Validators.required,
      ]),
    });
    this.form_campos = new FormGroup({
      sigla: new FormControl("", []),
      descricao: new FormControl("", []),
      // schema: new FormControl("", []),
      // tabela: new FormControl("", []),
      // campo: new FormControl("", []),
      sql: new FormControl("", []),
      quantidade_caracteres: new FormControl(null, []),
      padrao: new FormControl("", []),
      ordem: new FormControl("", []),
    });
    // this.form_campos.get('schema').disable();
    // this.form_campos.get('tabela').disable();
    // this.form_campos.get('campo').disable();
    this.form_campos.get('sql').disable();
    this.listarTipoLayout();
    // this.listarSchemas();
  }

  public listarTipoLayout(): void{
    this.tipoLayoutService.list().subscribe((tipos_layout: Array<TipoLayout>) => {
      this.tipos_layout = tipos_layout;
    });
  }

  // public listarSchemas(): void{
  //   this.tabelaService.listSchemas().subscribe((schemas: Array<Schema>) => {
  //     this.schemas = schemas;
  //   });
  // }
  //
  // public listarTabelas(schema): void{
  //   this.tabelaService.listTabelas(schema).subscribe((tabelas: Array<Tabela>) => {
  //     this.tabelas = tabelas;
  //   });
  // }
  //
  // public listarCampos(tabela, schema): void{
  //   this.tabelaService.listCampos(tabela, schema).subscribe((campos: Array<Campo>) => {
  //     this.campos = campos;
  //   });
  // }

  save(): void {
    this.cabecalho_layout.codigo_tipo_layout = this.form.get('codigo_tipo_layout').value;
    let message: string = "";
    if(!this.form.get('codigo_tipo_layout').value) {
      message = "Informe o tipo de layout";
    } else if(this.cabecalho_layout.campos_cabecalho_layout.length == 0) {
      message = "Informe pelo menos um campo";
    } else {
      this.cabecalhoLayoutService.save(this.cabecalho_layout).subscribe((data: any) => {
        this.notifierService.notify('success', 'Cabeçalho cadastrado com sucesso');
        this.router.navigate(['layout/cabecalho']);
      }, (error) => {
        this.notifierService.notify('error', 'Ocorreu um erro ao cadastrar o cabeçalho, tente novamente');
      });
    }
    if(message){
      this.notifierService.notify('error', message);
    }
  }

  prepararCampos(): void{
    this.form_campos.patchValue({
      sigla: "",
      descricao: "",
      // schema: "",
      // tabela: "",
      // campo: "",
      sql: "",
      quantidade_caracteres: "",
      padrao: "",
      ordem: "",
    });
    // this.form_campos.get('schema').disable();
    // this.form_campos.get('tabela').disable();
    // this.form_campos.get('campo').disable();
    this.form_campos.get('sql').enable();
    this.form_campos.get('padrao').enable();
    this.existe_padrao = true;
  }

  adicionarCampo(): void{
    let campo_cabecalho_layout: CampoCabecalhoLayout = new CampoCabecalhoLayout();
    let msg: Array<string> = [];
    campo_cabecalho_layout.quantidade_caracteres = this.form_campos.get('quantidade_caracteres').value;
    campo_cabecalho_layout.descricao = this.form_campos.get('descricao').value;
    campo_cabecalho_layout.sigla = this.form_campos.get('sigla').value;
    if(!this.form_campos.get('quantidade_caracteres').value){
      msg.push("Informe a quantidade de caracteres");
    }else if(this.existe_padrao && (!this.form_campos.get('padrao').value || this.form_campos.get('quantidade_caracteres').value != this.form_campos.get('padrao').value.length)){
      msg.push('A quantidade de caracteres do padrão não está igual a quantidade de caracteres informada');
    } else if(!this.existe_padrao && (!this.form_campos.get('schema').value || !this.form_campos.get('tabela').value || !this.form_campos.get('campo').value)){
      msg.push("Informe os campos schema, tabela e campo");
    }
    if(msg.length > 0){
      msg.forEach((message: string) => {
        this.notifierService.notify('error', message);
      });
    } else {
      if (this.form_campos.get('padrao').value) {
        campo_cabecalho_layout.padrao = this.form_campos.get('padrao').value;
        // campo_cabecalho_layout.schema = "";
        // campo_cabecalho_layout.tabela = "";
        // campo_cabecalho_layout.campo = "";
        campo_cabecalho_layout.sql = "";
      } else {
        campo_cabecalho_layout.padrao = "";
        // campo_cabecalho_layout.schema = this.form_campos.get('schema').value;
        // campo_cabecalho_layout.tabela = this.form_campos.get('tabela').value;
        // campo_cabecalho_layout.campo = this.form_campos.get('campo').value;
        campo_cabecalho_layout.sql = this.form_campos.get('sql').value;
      }
      this.cabecalho_layout.campos_cabecalho_layout.push(campo_cabecalho_layout);
      $('#md-layout-form').modal('hide');
    }
  }

  removerLinha(i: number): void{
    let campos_cabecalho_layout: Array<CampoCabecalhoLayout> = [];
    if(this.cabecalho_layout.campos_cabecalho_layout.length > 0){
      this.cabecalho_layout.campos_cabecalho_layout.forEach((campo_cabecalho: CampoCabecalhoLayout, index) => {
        if(index != i) {
          campos_cabecalho_layout.push(campo_cabecalho);
        }
      });
    }
    this.cabecalho_layout.campos_cabecalho_layout = campos_cabecalho_layout;
  }

  definirCampoPadrao(): void{
    this.existe_padrao = !this.existe_padrao;
    if(this.existe_padrao){
      // this.form_campos.get('schema').disable();
      // this.form_campos.get('tabela').disable();
      // this.form_campos.get('campo').disable();
      this.form_campos.get('sql').disable();
      this.form_campos.get('padrao').enable();
    }else{
      // this.form_campos.get('schema').enable();
      // this.form_campos.get('tabela').enable();
      // this.form_campos.get('campo').enable();
      this.form_campos.get('sql').enable();
      this.form_campos.get('padrao').disable();
    }
    this.form_campos.patchValue({
      padrao: "",
      sql: "",
      // schema: "",
      // tabela: "",
      // campo: "",
    });
  }

  voltar(): void{
    this.router.navigate(['layout/cabecalho']);
  }

}
